import { datadogRum, removeRumGlobalContext, RUMContextKeys } from 'common/services/RUM'

import { ActionTypeKeys } from 'common/actions'

const tracingMiddleware = (store) => (next) => (action) => {
  try {
    switch (action.type) {
      case ActionTypeKeys.LEAD_INITIALIZED:
        if (action.lead?.uuid) {
          datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_LEAD_UUID, action.lead.uuid)
        } else {
          removeRumGlobalContext(RUMContextKeys.DD_CTX_LEAD_UUID)
          removeRumGlobalContext(RUMContextKeys.DD_CTX_LEAD_RETURNING)
        }
        break
      case ActionTypeKeys.SESSION_INITIALIZED:
        if (action.sessionUuid) {
          datadogRum.addRumGlobalContext(RUMContextKeys.DD_CTX_SESSION_UUID, action.sessionUuid)
        } else {
          removeRumGlobalContext(RUMContextKeys.DD_CTX_SESSION_UUID)
        }
        break
      default:
    }
  } catch (err) {
    console.error('TRACING MIDDLEWARE ERROR', err)
  }

  next(action)
}

export default tracingMiddleware
